import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';

export const checkErrorMock: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EconomicSanctions$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'EconomicSanctions',
        statusCode: ControllerStatus.CHECK_ERROR,
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          controlData: {
            errorDetails: 'Error: Failed to create ticket for companyId 113: 400 - Bad Request',
          },
          expirationDateTime: '2025-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestDocumentIds: [],
          responseDocumentIds: [],
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/PoliticalExposedPerson$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'PoliticalExposedPerson',
        statusCode: ControllerStatus.CHECK_ERROR,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          controlData: {
            errorDetails: 'Error: Failed to create ticket for companyId 113: 400 - Bad Request',
          },
          expirationDateTime: '2025-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestDocumentIds: [],
          responseDocumentIds: [],
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EnergyPolicy$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'EnergyPolicy',
        statusCode: ControllerStatus.CHECK_ERROR,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          controlData: {
            errorDetails: 'Error: Failed to create ticket for companyId 113: 400 - Bad Request',
          },
          expirationDateTime: '2025-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestDocumentIds: [],
          responseDocumentIds: [],
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/SensitiveCountry$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'SensitiveCountry',
        statusCode: ControllerStatus.CHECK_ERROR,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          controlData: {
            errorDetails: 'Error: Failed to create ticket for companyId 113: 400 - Bad Request',
          },
          expirationDateTime: '2025-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestDocumentIds: [],
          responseDocumentIds: [],
        },
      } satisfies ControllerDetails,
    },
  },
];
